import React, { useEffect, useState } from "react";
import Navbar from "../../../atoms/navbar";
import { useNavigate, useParams } from "react-router";
import "../../travel-authority/print/styles.css"
import { QRCodeSVG } from "qrcode.react";

import {
    Layout,
    Alert,
    Collapse,
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
    Modal,
    Affix,
    Timeline,
} from "antd";
import { use } from "react";
import { QuestionOutlined } from "@ant-design/icons";
import { requestToken } from "../../../auth/AuthServices";
import HeaderFarms from "../../../utils/header_farms";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../../../config/api.config";
import API from "../../../services";
import { Block, Confirm, Report, Loading } from "notiflix";
export default function BiddingView() {
    const [items, setItems] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [biddingHdr, setBiddingHdr] = useState({});
    const [biddingApproval, setBiddingApproval] = useState([]);
    const [biddingComments, setBiddingComments] = useState([]);
    const [approval, setApproval] = useState([]);
    const { instance, accounts } = useMsal();
    const [currentSession, setCurrentSession] = useState(
        JSON.parse(localStorage.getItem("session_signin"))
    );

    let { id } = useParams();

    const getDetailBidding = async () => {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };
        const responseToken = await instance.acquireTokenSilent(request).catch(e => {
            console.error("Token acquisition failed", e);
            throw e;
        });
        const accessToken = responseToken.accessToken;
        const headers = HeaderFarms(accessToken);

        const response = await API.BiddingDetail(headers, id);
        if (response.code === 200) {
            const data = await response.data;
            setBiddingHdr(data.biddingHdr);
            setItems(data.biddingItem);
            setVendors(data.biddingVendor);
            setBiddingApproval(data.approval.data.detail);
            setApproval(data.approval.data);
            setBiddingComments(data.biddingHdr.comments);
            console.log("Bidding Comments:", data.biddingHdr.comments);
        } else {
            console.error("Error fetching bidding details:", response.statusText);
        }
    }

    function convertDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    function RequestToken() {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };

        instance
            .acquireTokenSilent(request)
            .then((response) => {
                if (!currentSession) {
                    getUser(response.accessToken);
                }

            })
            .catch((e) => {
                handleLogin(instance);
                console.error(e);
            });
    }

    function handleLogin(instance) {
        instance
            .loginRedirect(loginRequest)
            .then(() => { })
            .catch((e) => {
                console.error(e);
            });
    }

    async function getUser(token) {
        try {
            let user = await API.getUserCredential(HeaderFarms(token), {
                access_token: token,
            });
            setCurrentSession(user);
        } catch (error) {
            console.error(error);
        }
    }

    const formatNumber = (value) => {
        return new Intl.NumberFormat('id-ID', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    };

    useEffect(() => {
        RequestToken();
        if (id) {
            getDetailBidding();
        } else {
            message.error("Bidding ID is required to view details.");
        }
    }, [id]);

    return (
        <>
            <div className="container">
                <div style={{ alignSelf: "center" }} className="container mt-3">
                    <div className="row print">
                        <h5 className="text-center">Bidding Analyst Report</h5>
                        <p className="text-center">No: {biddingHdr.id_record}</p>

                        <div className="col-12">
                            <table style={{ width: "100%" }} className="table table-bordered">
                                <tbody>
                                    <tr style={{ backgroundColor: "#fbdf2a" }}>
                                        <td colSpan={4}>Informasi Vendor</td>
                                        {vendors.map((vendor, index) => (
                                            <td key={index} colSpan={3}>{vendor.vendor_name}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>Alamat / PIC</td>
                                        {vendors.map((vendor, index) => (
                                            <td key={index} colSpan={3}>{vendor.address} / {vendor.pic}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>No Telpon</td>
                                        {vendors.map((vendor, index) => (
                                            <td key={index} colSpan={3}>{vendor.telp}</td>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>Req Number: {biddingHdr.pr_num}</td>
                                        {vendors.map((vendor, index) => (
                                            <td key={index} colSpan={3}>{vendor.quotation_number}</td>
                                        ))}
                                    </tr>
                                    <tr style={{ backgroundColor: "#fbdf2a" }}>
                                        <td>No</td>
                                        <td>Description</td>
                                        <td>Qty</td>
                                        <td>Uom</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td style={{ alignSelf: "center" }} className="text-center">Harga Sebelum</td>
                                                <td style={{ alignSelf: "center" }} className="text-center">Harga Sesudah</td>
                                                <td style={{ alignSelf: "center" }} className="text-center">Total Harga</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    {items.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.item_name}</td>
                                            <td>{item.qty}</td>
                                            <td>{item.uom}</td>
                                            {vendors.map((vendor, vIndex) => (
                                                <React.Fragment key={vIndex}>
                                                    <td className="text-end">{vendor?.currency} {formatNumber(vendor.items[index].price_before)}</td>
                                                    <td className="text-end">{vendor?.currency} {formatNumber(vendor.items[index].price_after)}</td>
                                                    <td className="text-end">{vendor?.currency} {formatNumber(vendor.items[index].total_price)}</td>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    ))}
                                    <tr>
                                        <td rowSpan={9} colSpan={2}>Term and Condition</td>
                                        <td colSpan={2}>Diskon</td>

                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td></td>
                                                <td></td>
                                                <td className="text-end">{vendor?.currency} {formatNumber(vendor.discount_price)}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Harga Setelah Diskon</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td></td>
                                                <td></td>
                                                <td className="text-end">{vendor?.currency} {formatNumber(vendor.total_price - vendor.discount_price)}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>PPN</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td></td>
                                                <td></td>
                                                <td className="text-end">{vendor?.currency} {formatNumber(vendor.tax_price)}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Grand Total</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td></td>
                                                <td></td>
                                                <td className="text-end">{vendor?.currency} {formatNumber(vendor.grand_total)}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Payment</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td colSpan={3}>{vendor.payment_method}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Franco</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td colSpan={3}>{vendor.franco}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Garansi</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td colSpan={3}>{vendor.warranty}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Duration</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td colSpan={3}>{vendor.payment_term}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Keterangan</td>
                                        {vendors.map((vendor, vIndex) => (
                                            <React.Fragment key={vIndex}>
                                                <td colSpan={3}>{vendor.information}</td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                            <table style={{ width: "100%" }} className="table">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%" }}><b>Vendor Terpilih</b></td>
                                        <td style={{ width: "70%", backgroundColor: "#fbdf2a" }}>{biddingHdr.vendor_selected}</td>
                                    </tr>
                                    <tr>
                                        <td ><b>Catatan Jika bukan Harga Terendah</b></td>
                                        <td>{biddingHdr.information}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table style={{ width: "100%" }} className="table text-central">
                                <tbody className="text-center">
                                    <tr>
                                        <td style={{ backgroundColor: "#fbdf2a" }} key={`name-`}>{biddingHdr.buyer_name}</td>
                                        {biddingApproval.map((approval, index) =>
                                            <td style={{ backgroundColor: "#fbdf2a" }} key={`name-${index}`}>{approval.approver?.fullname}</td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td key={'status-'}>Prepared</td>
                                        {biddingApproval.map((approval, index) =>
                                            <td key={`status-${index}`}>
                                                {approval.status === true
                                                    ? 'Approved'
                                                    : approval.status === false && approval.rejected === true
                                                        ? 'Rejected'
                                                        : 'Pending'}
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td>
                                            {convertDate(biddingHdr.created_at)}
                                        </td>
                                        {biddingApproval.map((approval, index) =>
                                            <td key={`name-${index}`}>{convertDate(approval.updatedAt)}</td>
                                        )}
                                    </tr>

                                </tbody>
                            </table>
                            <div>
                                {biddingComments.map((comment, index) => (
                                    <div>
                                        <p key={index}>&gt;&gt;<b>{comment.name} - {convertDate(comment.date)}</b></p>
                                        <p style={{ paddingLeft: "20px" }}>{comment.comment}</p>
                                    </div>

                                ))}
                            </div>

                            <div className="col-md-12 text-center">
                                <QRCodeSVG
                                    size={130}
                                    style={{ padding: 10 }}
                                    value={`${window.location.origin}/wf/approved/${approval.approval_key}`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}